/**
 * NETLIFY WAVE: asset-quality switch. The decimated `-dec` GLB sets (40 MB
 * total, 5% collapse) are the RUNTIME DEFAULT everywhere; the high-quality
 * source GLBs (~340 MB) stay in the repo and load with `?hq=1` for local art
 * review. Deploy builds prune the HQ sets from dist entirely
 * (scripts/prune-hq-assets.mjs), so the published bundle only carries -dec.
 */
import { getSettings } from '../settings/store.js';

const useHighQualityAssets = (): boolean => {
  const fromUrl = new URLSearchParams(window.location.search).get('hq') === '1';
  return fromUrl || getSettings().graphics.assetQuality === 'hq';
};

export type AssetKind = 'ships' | 'stations' | 'weapons';

/** Base directory for a decimated-capable asset kind (with trailing slash). */
export const assetDir = (kind: AssetKind): string =>
  useHighQualityAssets() ? `/assets/${kind}/` : `/assets/${kind}-dec/`;

/** The Cenotaph hero GLB (the one decimated body asset). */
export const cenotaphGlbUrl = (): string =>
  useHighQualityAssets() ? '/assets/bodies/cenotaph.glb' : '/assets/bodies-dec/cenotaph.glb';
